import { render, staticRenderFns } from "./WrongBookCard.vue?vue&type=template&id=5c94deb5&scoped=true&"
import script from "./WrongBookCard.vue?vue&type=script&lang=js&"
export * from "./WrongBookCard.vue?vue&type=script&lang=js&"
import style0 from "./WrongBookCard.vue?vue&type=style&index=0&id=5c94deb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c94deb5",
  null
  
)

component.options.__file = "WrongBookCard.vue"
export default component.exports